import { useMemo } from 'react';
import { createPersonSchema } from '@cp/entities/resume';
import { useCareerDeclination } from '@cp/entities/career';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { catalogOptionCoreApi } from '@cp/entities/catalogOption';

export const useProfilePageSchema = (catalogItem?: CatalogItemViewModel) => {
  const declination = useCareerDeclination();
  const { data: options } = catalogOptionCoreApi.endpoints.getOptions.useQuery(
    { careerId: catalogItem?.careerId as number, active: true },
    { skip: !catalogItem },
  );
  return useMemo(() => {
    if (!catalogItem || typeof catalogItem.clientProfile === 'undefined' || typeof catalogItem.city === 'undefined') {
      return {};
    }
    return {
      '@type': 'ProfilePage',
      mainEntity: createPersonSchema(
        declination,
        ({ id }) => (options ? options.items.find((option) => option.id === id)?.translation.title || '' : ''),
        catalogItem as CatalogItemViewModel & Required<Pick<CatalogItemViewModel, 'clientProfile' | 'city'>>,
      ),
    };
  }, [declination, options, catalogItem]);
};
